import { CurveState } from '@gong/curve-math';

/**
 * Passport lines for a launch. Seed and creator purchase are always two
 * records. Callers must not add them into one number (ADR-0006).
 */
export interface LaunchPassportLine {
  kind: 'seed' | 'dev-buy';
  ton: bigint;
  jettons: bigint;
}

export function launchPassportLines(
  seedTon: bigint,
  devBuyTon: bigint,
  seedJettons: bigint = 0n,
  devBuyJettons: bigint = 0n,
): [LaunchPassportLine, LaunchPassportLine] {
  return [
    { kind: 'seed', ton: seedTon, jettons: seedJettons },
    { kind: 'dev-buy', ton: devBuyTon, jettons: devBuyJettons },
  ];
}

export function passportFromState(
  seedTon: bigint,
  devBuyTon: bigint,
  state: Pick<CurveState, 'seedJettons' | 'devBuyJettons'>,
): [LaunchPassportLine, LaunchPassportLine] {
  return launchPassportLines(seedTon, devBuyTon, state.seedJettons, state.devBuyJettons);
}
